const imgPath = "https://www.digitalavenue.org/profiles/";

export const getImgUrl = (profile) => {
  if (profile.photo) {
    return imgPath + profile.photo;
  }
  if (profile.Gender === "Male") {
    return "https://bootdey.com/img/Content/avatar/avatar1.png";
  }
  if (profile.Gender === "Female") {
    return "https://bootdey.com/img/Content/avatar/avatar8.png";
  }
  return "https://bootdey.com/img/Content/avatar/avatar1.png";
};

export function showInResults(user) {
  let canReturnMap = [];
  Object.entries(this.selectedChoices).map(([name, arr]) => {
    if (arr.length) {
      if (arr.includes(user[name])) {
        canReturnMap.push(true);
      } else {
        canReturnMap.push(false);
      }
    }
    return arr;
  });
  const canReturn = Object.values(canReturnMap).every(
    (value) => value === true
  );
  if (canReturn) return user;
}
